










import { Component, Mixins } from "vue-property-decorator";
import { StandardOption } from "../../../system/selectors/mixins";
import OptionDropDownSelector from "../../../system/selectors/OptionDropDownSelector.vue";
import SystemSettingSystemEditor from "./SystemSettingSystemEditor.vue";
import SystemSettingTerminalEditor from "./SystemSettingTerminalEditor.vue";

@Component({
  components: {
    OptionDropDownSelector,
    SystemSettingSystemEditor,
    SystemSettingTerminalEditor,
  }
})
export default class MstRegistriesEditor extends Mixins() {
  data(): any {
    return {
      contents: [
        new StandardOption<string>("SystemSetting-System", "system-setting-system-editor"),
        new StandardOption<string>("SystemSetting-Terminal", "system-setting-terminal-editor"),
      ],
      selectedContent: "system-setting-system-editor",
    };
  }
  contents: StandardOption<string>[];
  selectedContent: string;

  selectContent(key: string): void {
    this.selectedContent = key;
  }
}
